import { render, staticRenderFns } from "./LivePublishFlow.vue?vue&type=template&id=ba1307aa&scoped=true"
import script from "./LivePublishFlow.vue?vue&type=script&lang=js"
export * from "./LivePublishFlow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba1307aa",
  null
  
)

export default component.exports